<template>
  <div class="container">
    <LeftMenu :toggleLeftMenu="toggleLeftMenu" :showLeftMenu="showLeftMenu" :leftMenuLoading="leftMenuLoading" />
    <div class="main" :class="{ 'main--expand': !showLeftMenu }">
      <Header :toggleNotification="toggleNotification" :showNotification="showNotification" />
      <div class="pages">
        <router-view v-slot="{ Component }">
          <transition mode="out-in" enter-active-class="animate__animated animate__fadeInDown"
            leave-active-class="animate__animated animate__fadeOutDown">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>

    <Notifications :toggleNotification="toggleNotification" :showNotification="showNotification" />
    <transition name="zoom" mode="out-in">
      <AddCustomer v-if="showAddCustomerModal" />
      <AddFamilyMember v-else-if="showAddFamilyMemberModal" />
      <AddSearchFamilyMember v-else-if="showAddSearchFamilyMemberModal" />
      <AddCompanyModal v-else-if="showAddCompanyModal" />
      <AddPrivateModal v-else-if="showAddPrivateModal" />
      <LeadCustomerModal v-else-if="showCustomerLeadModal" />
      <TransferLeadsModal v-else-if="showTransferLeadsModal" />
      <AddLeadModal v-else-if="showAddLeadModal" />
      <EditPrivateEmailModal v-else-if="showEditPrivateEmailModal" />
      <EditCompanyEmailModal v-else-if="showEditCompanyEmailModal" />
      <AddUserModal v-else-if="showAddUserModal" />
      <ProfileModal v-else-if="showProfileModal" />
      <AddCustomerServices v-else-if="showAddCustomerServicesModal" />
      <AddPolicyModal v-else-if="showAddPolicyModal" />
      <AddActivityModal v-else-if="showAddActivityModal" />
      <AddPendencyModal v-else-if="showAddPendencyModal" />
      <AllFilesModal v-else-if="showFilesEditModal" />
      <AddNotesModal v-else-if="showAddNotesModal" />
      <AddCallsModal v-else-if="showAddCallsModal" />
      <AddMandateModal v-else-if="showAddMandateModal" />
      <AddInfoMandateModal v-else-if="showAddInfoMandateModal" />
      <MandateEmailModal v-else-if="mandateEmailModal.display" />
      <AddOfferModal v-else-if="showAddOfferModal" />
      <PolicyFilesModal v-else-if="showPolicyFilesModal" />
      <TerminationModal v-else-if="showTerminationModal" />
      <AddModelModal v-else-if="showAddModelModal" />
      <AddCompanyContactModal v-else-if="addCompanyContactModal" />
      <AddRoleModal v-else-if="showAddRoleModal" />
      <AddPermissionModal v-else-if="showAddPermissionModal" />
      <AddSaleCategoryModal v-else-if="showAddSaleCategoryModal" />
      <AddSecondSaleCategoryModal v-else-if="showAddSecondSaleCategoryModal" />
      <AddSaleCategoryCompanyModal v-else-if="showAddSaleCategoryCompanyModal" />
      <AddPotentialPolicyModal v-else-if="showAddPotentialPolicyModal" />
      <SearchPotentialCustomerModal v-else-if="showSearchPotentialCustomerModal" />
      <PolicyProvisionModal v-else-if="showPolicyProvisionModal" />
      <AddAccidentModal v-else-if="showAddAccidentModal" />
      <PolicyEmailHistoryModal v-else-if="showPolicyEmailHistoryModal" />
      <ChangePassword v-else-if="showChangePasswordModal" />
      <AddInvoiceModal v-else-if="showAddInvoiceModal" />
      <AddTransactionModal v-else-if="showAddTransactionModal" />
      <PayoutReviewModal v-else-if="showPayoutReviewModal" />
      <DeleteModal v-else-if="deleteModal.display" />
      <ResetPasswordModal v-else-if="showResetPasswordModal" />
      <TaxesModal v-else-if="showTaxesModal" />
      <AddTeamModal v-else-if="showAddTeamModal" />
      <AddTeamTaxModal v-else-if="showAddTeamTaxModal" />
      <PolicyProvisionImportModal v-else-if="showPolicyProvisionImportModal" />

      <LeadImportModal v-else-if="showLeadImportModal" />
    </transition>
    <transition name="fade">
      <div class="container__blur" v-if="
        showAddCompanyModal ||
        showAddPrivateModal ||
        showCustomerLeadModal ||
        showAddLeadModal ||
        showEditPrivateEmailModal ||
        showEditCompanyEmailModal ||
        showAddUserModal ||
        showProfileModal ||
        showAddCustomerModal ||
        showAddSearchFamilyMemberModal ||
        showAddFamilyMemberModal ||
        showAddCustomerServicesModal ||
        showAddPolicyModal ||
        showAddActivityModal ||
        showAddPendencyModal ||
        showFilesEditModal ||
        showAddNotesModal ||
        showAddCallsModal ||
        showAddMandateModal ||
        showAddInfoMandateModal ||
        mandateEmailModal.display ||
        showAddOfferModal ||
        showPolicyFilesModal ||
        showTerminationModal ||
        showAddModelModal ||
        addCompanyContactModal ||
        showAddRoleModal ||
        showAddPermissionModal ||
        showAddSaleCategoryModal ||
        showAddSecondSaleCategoryModal ||
        showAddSaleCategoryCompanyModal ||
        showAddPotentialPolicyModal ||
        showSearchPotentialCustomerModal ||
        showPolicyProvisionModal ||
        showAddAccidentModal ||
        showPolicyEmailHistoryModal ||
        showChangePasswordModal ||
        showAddInvoiceModal ||
        showAddTransactionModal ||
        showPayoutReviewModal ||
        deleteModal.display ||
        showResetPasswordModal ||
        showTaxesModal ||
        showAddTeamModal ||
        showAddTeamTaxModal ||
        showPolicyProvisionImportModal ||
        showLeadImportModal ||
        showTransferLeadsModal
      "></div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import Header from "@/partials/Header";
import LeftMenu from "@/partials/LeftMenu";
import Notifications from "@/partials/Notifications";
import AddCustomer from "@/components/AddCustomer";
import DeleteModal from "@/components/DeleteModal";
import AddCompanyModal from "@/components/AddCompanyModal";
import AddPrivateModal from "@/components/AddPrivateModal";
import LeadCustomerModal from "@/components/LeadCustomerModal";
import AddLeadModal from "@/components/AddLeadModal";
import EditPrivateEmailModal from "@/components/EditPrivateEmailModal";
import EditCompanyEmailModal from "@/components/EditCompanyEmailModal";
import AddUserModal from "@/components/AddUserModal";
import ProfileModal from "@/components/ProfileModal";
import AddCustomerServices from "@/components/AddCustomerServices";
import TransferLeadsModal from "@/components/TransferLeadsModal";
import AddPolicyModal from "@/components/AddPolicyModal";
import AddActivityModal from "@/components/AddActivityModal";
import AddPendencyModal from "@/components/AddPendencyModal";
import AllFilesModal from "@/components/AllFilesModal";
import AddNotesModal from "@/components/AddNotesModal";
import AddCallsModal from "@/components/AddCallsModal";
import AddMandateModal from "@/components/AddMandateModal";
import MandateEmailModal from "@/components/MandateEmailModal";
import AddOfferModal from "@/components/AddOfferModal";
import PolicyFilesModal from "@/components/PolicyFilesModal";
import TerminationModal from "@/components/TerminationModal";
import AddModelModal from "@/components/AddModelModal";
import AddCompanyContactModal from "@/components/AddCompanyContactModal";
import AddRoleModal from "@/components/AddRoleModal";
import AddPermissionModal from "@/components/AddPermissionModal";
import AddSaleCategoryModal from "@/components/AddSaleCategoryModal";
import AddSecondSaleCategoryModal from "@/components/AddSecondSaleCategoryModal";
import AddPotentialPolicyModal from "@/components/AddPotentialPolicyModal";
import SearchPotentialCustomerModal from "@/components/SearchPotentialCustomerModal";
import PolicyProvisionModal from "@/components/PolicyProvisionModal";
import AddAccidentModal from "@/components/AddAccidentModal";
import PolicyEmailHistoryModal from "@/components/PolicyEmailHistoryModal";
import AddInvoiceModal from "@/components/AddInvoiceModal";
import AddTransactionModal from "@/components/AddTransactionModal";
import PayoutReviewModal from "@/components/PayoutReviewModal";
import ResetPasswordModal from "@/components/ResetPasswordModal";
import TaxesModal from "@/components/TaxesModal";
import AddTeamModal from "@/components/AddTeamModal";
import AddTeamTaxModal from "@/components/AddTeamTaxModal";
import AddFamilyMember from "@/components/AddFamilyMember";
import AddSearchFamilyMember from "@/components/AddSearchFamilyMember";
import AddSaleCategoryCompanyModal from "@/components/AddSaleCategoryCompanyModal";
import PolicyProvisionImportModal from "@/components/PolicyProvisionImportModal";
import ChangePassword from "../components/AccountDetails/ChangePassword.vue";
import LeadImportModal from "../components/LeadImportModal.vue";
import AddInfoMandateModal from "../components/AddInfoMandateModal.vue";
//import statics from "@/statics";

const store = useStore();
const instance = getCurrentInstance();

// Reactive data
const showLeftMenu = ref(true);
const showNotification = ref(false);
const notificationsInterval = ref(null);
const leftMenuLoading = ref(false);

// Computed properties
const showAddCompanyModal = computed(() => store.getters.showAddCompanyModal);
const showAddPrivateModal = computed(() => store.getters.showAddPrivateModal);
const showCustomerLeadModal = computed(() => store.getters.showCustomerLeadModal);
const showAddLeadModal = computed(() => store.getters.showAddLeadModal);
const showEditPrivateEmailModal = computed(() => store.getters.showEditPrivateEmailModal);
const showEditCompanyEmailModal = computed(() => store.getters.showEditCompanyEmailModal);
const showAddUserModal = computed(() => store.getters.showAddUserModal);
const showProfileModal = computed(() => store.getters.showProfileModal);
const showAddCustomerModal = computed(() => store.getters.showAddCustomerModal);
const showAddSearchFamilyMemberModal = computed(() => store.getters.showAddSearchFamilyMemberModal);
const showAddFamilyMemberModal = computed(() => store.getters.showAddFamilyMemberModal);
const showTransferLeadsModal = computed(() => store.getters.showTransferLeadsModal);
const showAddCustomerServicesModal = computed(() => store.getters.showAddCustomerServicesModal);
const showAddPolicyModal = computed(() => store.getters.showAddPolicyModal);
const showAddPendencyModal = computed(() => store.getters.showAddPendencyModal);
const showAddNotesModal = computed(() => store.getters.showAddNotesModal);
const showAddCallsModal = computed(() => store.getters.showAddCallsModal);
const showAddMandateModal = computed(() => store.getters.showAddMandateModal);
const showAddInfoMandateModal = computed(() => store.getters.showAddInfoMandateModal);
const mandateEmailModal = computed(() => store.getters.mandateEmailModal);
const showAddOfferModal = computed(() => store.getters.showAddOfferModal);
const showAddActivityModal = computed(() => store.getters.showAddActivityModal);
const showPolicyFilesModal = computed(() => store.getters.showPolicyFilesModal);
const showTerminationModal = computed(() => store.getters.showTerminationModal);
const showAddModelModal = computed(() => store.getters.showAddModelModal);
const addCompanyContactModal = computed(() => store.getters.addCompanyContactModal);
const showAddRoleModal = computed(() => store.getters.showAddRoleModal);
const showAddPermissionModal = computed(() => store.getters.showAddPermissionModal);
const showAddSaleCategoryModal = computed(() => store.getters.showAddSaleCategoryModal);
const showAddSecondSaleCategoryModal = computed(() => store.getters.showAddSecondSaleCategoryModal);
const showAddSaleCategoryCompanyModal = computed(() => store.getters.showAddSaleCategoryCompanyModal);
const showAddPotentialPolicyModal = computed(() => store.getters.showAddPotentialPolicyModal);
const showSearchPotentialCustomerModal = computed(() => store.getters.showSearchPotentialCustomerModal);
const showPolicyProvisionModal = computed(() => store.getters.showPolicyProvisionModal);
const showAddAccidentModal = computed(() => store.getters.showAddAccidentModal);
const showPolicyEmailHistoryModal = computed(() => store.getters.showPolicyEmailHistoryModal);
const showChangePasswordModal = computed(() => store.getters.showChangePasswordModal);
const showAddInvoiceModal = computed(() => store.getters.showAddInvoiceModal);
const showAddTransactionModal = computed(() => store.getters.showAddTransactionModal);
const showPayoutReviewModal = computed(() => store.getters.showPayoutReviewModal);
const loggedUser = computed(() => store.getters.loggedUser);
const deleteModal = computed(() => store.getters.deleteModal);
const showResetPasswordModal = computed(() => store.getters.showResetPasswordModal);
const showTaxesModal = computed(() => store.getters.showTaxesModal);
const showAddTeamModal = computed(() => store.getters.showAddTeamModal);
const showAddTeamTaxModal = computed(() => store.getters.showAddTeamTaxModal);
const showPolicyProvisionImportModal = computed(() => store.getters.showPolicyProvisionImportModal);
const showLeadImportModal = computed(() => store.getters.showLeadImportModal);
const showFilesEditModal = computed(() => store.getters.showFilesEditModal);

// Methods
const setLanguage = () => {
  const validLocales = ['en', 'de', 'fr', 'it'];
  const normalizeLocaleCode = (value, fallback = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de') => {
    if (typeof value === 'string') {
      return validLocales.includes(value) ? value : fallback;
    }

    if (value && typeof value === 'object') {
      const candidate = value.code || value.language || value.name;
      if (typeof candidate === 'string' && validLocales.includes(candidate)) {
        return candidate;
      }
    }

    return fallback;
  };

  const userLocale = loggedUser.value?.language ?? loggedUser.value?.settings?.locale;
  const fallback = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de';
  const localeCode = normalizeLocaleCode(userLocale, normalizeLocaleCode(window.localStorage.getItem('language'), fallback));

  store.commit("setLanguage", localeCode);

  const i18n = instance.proxy.$i18n;
  if (i18n) {
    i18n.locale = localeCode;
  }
  window.localStorage.setItem("language", localeCode);
};

const toggleLeftMenu = (state) => {
  showLeftMenu.value = state;
};

const toggleNotification = (state) => {
  showNotification.value = state;
};

const startFetchingNotifications = async () => {
  await store.dispatch("getNotifications");
  //notificationsInterval.value = setInterval(async () => {
  // await store.dispatch("getNotifications");
  // }, statics.fetchNotificationTime);
};

// Lifecycle
onMounted(async () => {
  showLeftMenu.value = false;
  leftMenuLoading.value = true;
  await startFetchingNotifications();
  setLanguage();
  leftMenuLoading.value = false;
  // showLeftMenu.value = true;

  if (window.innerWidth < 680) {
    showLeftMenu.value = false;
  } else {
    showLeftMenu.value = true;
  }
});

onUnmounted(() => {
  clearInterval(notificationsInterval.value);
  showLeftMenu.value = true;
});
</script>

<style scoped lang="scss">
.container {
  display: flex;
  position: relative;
  overflow: hidden;

  .main {
    width: calc(100% - var(--app-sidebar-width));
    transition: width 0.2s ease;

    &--expand {
      width: calc(100% - var(--app-sidebar-collapsed-width));
    }

    .pages {
      height: calc(100% - var(--app-header-height));
      background: var(--bg-17);
      position: relative;
      padding: var(--app-page-padding);
      overflow: auto;
    }
  }

  .fade-leave-active {
    transition-delay: 0.3s;
  }

  &__blur {
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--modal-bg-1);
    backdrop-filter: blur(12px);
    z-index: 98;
  }
}
</style>
